import React from 'react';
import { CreateOrder } from '../../features/create-order/components';
import { PageContainer } from './styles';

export const CreateOrderPage: React.FC = () => {
  return (
    <PageContainer>
      <CreateOrder />
    </PageContainer>
  );
};
